import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { IconSize } from '../../../../models/types/icon-size.type';
import { NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';
import { TranslateDirective } from '../../../../directives/translate.directive';
import { BaryIconButtonComponent } from '../bary-icon-button/bary-icon-button.component';

@Component({
  selector: 'jhi-bary-specific-button',
  templateUrl: './bary-specific-button.component.html',
  styleUrls: ['./bary-specific-button.component.scss'],
  standalone: true,
  imports: [NgSwitch, MDBBootstrapModulesPro, BaryIconComponent, NgSwitchCase, NgSwitchDefault, TranslateDirective, BaryIconButtonComponent],
})
export class BarySpecificButtonComponent {
  @Input() type?: string;
  @Input() size: IconSize = 'lg';
  @Input() tooltip?: string;
  @Output() clickEvent = new EventEmitter<MouseEvent>();

  protected readonly FAS = FaDirectiveEnum.FAS;

  public handleClick($event: MouseEvent): void {
    this.clickEvent.emit($event);
  }
}
